import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
export default {
  props: {
    num: {
      type: Number,
      default: 6
    }
  },
  components: {
    CommonTitle: CommonTitle
  }
};